<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div
            class="card-header pb-0 d-flex justify-content-between align-items-center"
          >
            <h6>部落格文章管理</h6>
            <button
              class="btn btn-sm btn-success mb-0"
              @click="$router.push('/blog/new')"
              v-if="can('marketing.edit')"
            >
              新增文章
            </button>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <!-- Filters -->
            <div class="row mt-3 px-4">
              <div class="col-md-6">
                <label>搜尋</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="filters.search"
                  placeholder="搜尋標題或摘要"
                />
              </div>
              <div class="col-md-3">
                <label>狀態</label>
                <select class="form-control" v-model="filters.status">
                  <option value="">全部</option>
                  <option value="draft">草稿</option>
                  <option value="published">已發布</option>
                  <option value="scheduled">排程</option>
                  <option value="archived">封存</option>
                </select>
              </div>
              <div class="col-md-3 d-flex align-items-end">
                <button class="btn btn-primary btn-sm me-2" @click="fetchPosts">
                  搜尋
                </button>
                <button class="btn btn-secondary btn-sm" @click="resetFilters">
                  重置
                </button>
              </div>
            </div>

            <div class="table-responsive p-0 mt-3">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      文章
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      作者
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      分類
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      狀態
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      瀏覽數
                    </th>
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="post in posts" :key="post.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div v-if="post.featured_image">
                          <img
                            :src="post.featured_image"
                            class="avatar avatar-sm me-3 border-radius-lg"
                            alt="post"
                          />
                        </div>
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ post.title }}</h6>
                          <p class="text-xs text-secondary mb-0">
                            {{
                              post.summary
                                ? post.summary.substring(0, 50) + "..."
                                : ""
                            }}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
                        {{ post.author?.name || "Unknown" }}
                      </p>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ post.category?.name || "-" }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <soft-badge
                        :color="getStatusColor(post.status)"
                        variant="gradient"
                        size="sm"
                      >
                        {{ getStatusText(post.status) }}
                      </soft-badge>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ post.views_count || 0 }}
                      </span>
                    </td>
                    <td class="align-middle">
                      <a
                        href="javascript:;"
                        class="text-secondary font-weight-bold text-xs me-3"
                        @click="$router.push(`/blog/${post.id}/edit`)"
                        v-if="can('marketing.edit')"
                      >
                        編輯
                      </a>
                      <a
                        href="javascript:;"
                        class="text-danger font-weight-bold text-xs"
                        @click="deletePost(post.id)"
                        v-if="can('marketing.edit')"
                      >
                        刪除
                      </a>
                    </td>
                  </tr>
                  <tr v-if="posts.length === 0">
                    <td colspan="6" class="text-center py-4 text-secondary">
                      找不到文章
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoftBadge from "@/components/SoftBadge.vue";
import request from "@/utils/request";
import { hasPermission } from "@/utils/permissions";

export default {
  name: "Blog",
  components: {
    SoftBadge,
  },
  data() {
    return {
      posts: [],
      filters: {
        search: "",
        status: "",
      },
      currentUser: JSON.parse(localStorage.getItem("user") || "{}"),
    };
  },
  methods: {
    can(permission) {
      return hasPermission(this.currentUser, permission);
    },
    async fetchPosts() {
      try {
        const params = { ...this.filters };
        Object.keys(params).forEach(
          (key) =>
            (params[key] === "" || params[key] === null) && delete params[key]
        );

        const response = await request.get("/api/admin/blog/posts", { params });
        this.posts = response.data.data.data || response.data.data;
      } catch (error) {
        console.error("Failed to fetch posts", error);
      }
    },
    resetFilters() {
      this.filters = {
        search: "",
        status: "",
      };
      this.fetchPosts();
    },
    async deletePost(id) {
      this.$swal({
        title: "確定要刪除此文章嗎？",
        text: "此操作無法復原",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ea0606",
        confirmButtonText: "確定刪除",
        cancelButtonText: "取消",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await request.delete(`/api/admin/blog/posts/${id}`);
            this.fetchPosts();
            this.$swal.fire("已刪除", "文章已成功刪除。", "success");
          } catch (error) {
            console.error("Failed to delete post", error);
            this.$swal.fire("錯誤", "刪除失敗", "error");
          }
        }
      });
    },
    getStatusColor(status) {
      const colors = {
        draft: "secondary",
        published: "success",
        scheduled: "info",
        archived: "warning",
      };
      return colors[status] || "secondary";
    },
    getStatusText(status) {
      const texts = {
        draft: "草稿",
        published: "已發布",
        scheduled: "排程",
        archived: "封存",
      };
      return texts[status] || status;
    },
  },
  created() {
    this.fetchPosts();
  },
};
</script>
